var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.666 24C19.2934 24 24.666 18.6274 24.666 12C24.666 5.37258 19.2934 0 12.666 0C6.0386 0 0.666016 5.37258 0.666016 12C0.666016 18.6274 6.0386 24 12.666 24Z",
    fill: "#26A17B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9444 13.1067V13.1047C13.8615 13.1105 13.4332 13.1356 12.4801 13.1356C11.718 13.1356 11.1836 13.1144 10.9946 13.1047V13.1067C8.06403 12.9774 5.87818 12.4681 5.87818 11.8565C5.87818 11.2469 8.06596 10.7356 10.9946 10.6063V12.5993C11.1856 12.6128 11.7354 12.6456 12.4936 12.6456C13.4042 12.6456 13.8595 12.607 13.9444 12.5993V10.6083C16.8692 10.7395 19.0492 11.2488 19.0492 11.8584C19.0492 12.4681 16.8672 12.9774 13.9444 13.1086M13.9444 10.4018V8.61921H18.0248V5.90088H6.91612V8.61921H10.9965V10.4018C7.6801 10.5543 5.1875 11.2102 5.1875 11.9973C5.1875 12.7845 7.68203 13.4404 10.9965 13.5948V19.3092H13.9463V13.5948C17.257 13.4424 19.7457 12.7864 19.7457 11.9993C19.7457 11.2141 17.257 10.5562 13.9463 10.4038",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.a7b4eb6c451e064f6f37c475b479e146.svg";
export { ForwardRef as ReactComponent };